import { ApiHCA } from './api.hca'
import { ApiReports } from '../pages/Team/Reports/apis/api-reports'
import { ApiSignUp } from './api.signup'
import { ApiParticipation } from './api.participation'
import { ApiContent } from './api.content'
import { ApiPresent } from './api.present'
import Axios, { AxiosInstance } from 'axios'
import storageHelper from '../helpers/storage'
import { ApiAssignation } from './api.assignation'
import { ApiDashboard } from '../pages/Team/Reports/apis/api-dashboard'

const clients: AxiosInstance[] = [
    ApiSignUp,
    ApiHCA,
    ApiReports,
    ApiDashboard,
    ApiParticipation,
    ApiContent,
    ApiPresent,
    ApiAssignation,
    Axios,
]

export const setNewAccessToken = (token: string | null) => {
    if (!token) return removeToken()

    const bearer = `Bearer ${token}`
    if (bearer === ApiSignUp.defaults.headers.common.Authorization) return

    clients.forEach((client) => {
        if (client === Axios) client.defaults.headers.common.Authorization = token
        else client.defaults.headers.common.Authorization = bearer
    })

    // Serialización consistente
    storageHelper.setToken(token)
}

const removeToken = () => {
    clients.forEach((client) => {
        delete client.defaults.headers.common.Authorization
    })

    storageHelper.setToken(null)
}

export const recoveryAuthFromStorage = () => {
    const token = storageHelper.getToken()
    if (!token) return
    setNewAccessToken(token)
}

// Alias para compatibilidad
export const recoveryAuthFromLocalStorage = recoveryAuthFromStorage
